/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('popup.employee-payroll', ['popup', 'data.employee-payroll']);